module.exports = { JWT: function JWT() {} };